module.exports = __webpack_public_path__ + "static/questica-logo-2e3cc11e0a619f029b7ebb88fc5f00d9.png";